export const WHATSAPP_NUMBER = '919876543210';

export function createWhatsAppUrl(message = 'Hi! I need some help.') {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
